<template>
  <div class="home-grid">
    <a>
      <img
        class="newProject"
        @click="setValueEmpty"
      >
    </a>
    <a href="/openProject/">
      <img
        class="project"
      >
    </a>
    <a href="/dataBase/">
      <img class="bd">
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  components: {
  },
  beforeMount() {
    this.setCont(0);
  },
  methods: {
    setValueEmpty() {
      this.setCurrentProject('');
      this.resetNewProject();
      this.resetNewProjectOpenAir();
      this.$f7.views.main.router.navigate('/pageRegisterProject/');
    },
    ...mapActions('Database', ['setCurrentProject']),
    ...mapActions('ProjectGreenHouse', ['setCont', 'resetNewProject']),
    ...mapActions('ProjectOpenAir', ['resetNewProjectOpenAir']),
  },
};
</script>

<style lang="scss" scoped>
@import "./homeProject.scss";

</style>
